import { useTranslation } from "../hooks/useTranslation";

export default function FailedRegisteringWorkspace() {
    const t = useTranslation();
    return (
        <div className="analytics-container text-center">
            <h1 style={{ marginBottom: '0' }}>{t('Workspace Registration Failed')}</h1>
            <p style={{ marginTop: '0' }}>{t('Please try again.')}</p>
        </div>
    )
}

